export default "__VITE_ASSET__JHsIycsJ__"